import React from "react"
import { FontIcon } from "material-ui"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { grey500 } from "material-ui/styles/colors"
import { EFavoriteType, IFavoriteDocument } from "../../../models"
import * as api from "../../../api"
import AccountStore from "../../../stores/AccountStore"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import AppStateStore from "../../../stores/AppStateStore"
interface IProps {
    itemName: string
    isFavorite: boolean
    objectId: string
    favoriteType: EFavoriteType
    fontSize?: number
}

interface IState {
    isFavorite: boolean
    iconClass: string
    iconColor: string
}

export default class FavoriteSelector extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            isFavorite: props.isFavorite,
            iconClass: props.isFavorite ? "fa fa-star" : "fa fa-star-o",
            iconColor: props.isFavorite ? "#ffb300" : grey500
        }
        autobind(this)
    }

    updateFavoriteState(isFavorite: boolean) {
        if (isFavorite) this.addToFavorite() 
        else this.removeFromFavorite()
    }

    addToFavorite() {
        const favoriteDoc = {
            AccountId: AccountStore.getCurrentAccount().Id,
            UserId: AuthenticationStore.getLoggedInUser().Id,
            ObjectId: this.props.objectId,
            FavoriteType: this.props.favoriteType
        } as IFavoriteDocument

        AppStateStore.setProgressSnackbarContent("loading")
        api.addToFavorite(favoriteDoc).then(() => {
            this.setState({ iconClass: "fa fa-star", iconColor: "#ffb300" }, () => AppStateStore.setProgressSnackbarContent(`${this.props.itemName} ${strings.Add_To_Favorite_Message_Text}`))
        })
        .catch(() => AppStateStore.setProgressSnackbarContent(strings.something_went_wrong))
    }

    removeFromFavorite() {
        AppStateStore.setProgressSnackbarContent("loading")
        api.removeFromFavorite(this.props.objectId).then(() => {
            this.setState({ iconClass: "fa fa-star-o", iconColor: grey500 }, () => AppStateStore.setProgressSnackbarContent(`${this.props.itemName} ${strings.Remove_From_Favorite_Message_Text}`))
        })
        .catch(() => AppStateStore.setProgressSnackbarContent(strings.something_went_wrong))
    }

    render() {
        return (
            <FontIcon
                title={this.state.isFavorite ? strings.Remove_From_Favorite : strings.Add_To_Favorite}
                style={{ fontSize: this.props.fontSize ? this.props.fontSize : 22 , cursor: "pointer" }} 
                className={this.state.iconClass} 
                color={this.state.iconColor}
                onClick={() => {
                    this.setState((state) => ({ isFavorite: !state.isFavorite }), () => this.updateFavoriteState(this.state.isFavorite))
                }}
            />
          )
    }
  
}
